<div class="flex-grow pl-12">
  <div class="flex justify-end items-center text-8 leading-15px py-4 px-6">
    &nbsp;

    <!-- show msg for now, instead of retry button -->
    <span
      *ngIf="
        !data.isProgressWatcher.sgnl() &&
        !isUploadProcess &&
        isError &&
        (data.isPrepareImgErrorWatcher.$ | async) !== true
      "
      class="text-error text-10"
      >File upload failed, please try again</span
    >
    <!-- don't show retry for now, will show later -->
    <button
      *ngIf="
        false &&
        !data.isProgressWatcher.sgnl() &&
        !isUploadProcess &&
        isError &&
        (data.isPrepareImgErrorWatcher.$ | async) !== true
      "
      tabindex="-1"
      [disabled]="data.isProgressWatcher.sgnl()"
      [ngClass]="{ 'opacity-50': data.isProgressWatcher.sgnl() }"
      class="font-semibold cursor-pointer"
      (click)="retry()"
    >
      {{ 'btn.retry' | transloco }}&nbsp;
    </button>
    <button
      *ngIf="!isBlobLoaded && isUuuidReceived"
      type="button"
      tabindex="-1"
      (click)="cancelCreation()"
    >
      {{ 'btn.cancel' | transloco }}
    </button>
    <div
      *ngIf="!isError && isTypeDetectionProgress; else fullyLoadedTmpl"
      class="flex gap-4 -ml-3"
    >
      <div class="text-10">Type detection</div>
    </div>

    <ng-template #fullyLoadedTmpl>
      <div data-cy="done" *ngIf="isBlobLoaded" class="font-semibold">
        {{ 'common.done' | transloco }}
      </div>
    </ng-template>
  </div>

  <mat-progress-bar
    mode="determinate"
    [value]="progressVal || 0"
  ></mat-progress-bar>

  <div class="flex justify-between items-center text-8 leading-15px py-4 px-6">
    <ng-container
      *ngIf="!isBlobLoaded || data.isProgressWatcher.sgnl(); else loadedTmpl"
    >
      <ng-container *ngIf="!isError">
        <div class="flex justify-start items-center">
          <ng-container *ngIf="!isBlobLoaded">
            <span class="font-semibold">{{ uploaded | number: '1.2-2' }}</span
            >&nbsp;/&nbsp;
          </ng-container>
          {{ size | number: '1.2-2' }}&nbsp;{{ type | titlecase }}
        </div>
        <div>{{ progressVal | number: '1.0-0' }}%</div>
      </ng-container>
      <div
        *ngIf="!data.isProgressWatcher.sgnl() && isError && !isUploadProcess"
        class="flex justify-end items-center flex-grow"
      >
        &nbsp;<span class="text-error mr-4">{{
          'common.error' | transloco
        }}</span>
        <div
          [tdvTooltip]="{
            template: tooltipTmpl,
            placement: 'right',
          }"
          class="flex justify-center items-center"
        >
          <tdv-icon-svg-info
            color="warning"
            class="opacity-50 w-16 h-16 ml-3"
          ></tdv-icon-svg-info>

          <ng-template #tooltipTmpl>
            <div class="p-8">
              <span class="text-10 text-error"> {{ errorMsg }} </span>
            </div>
          </ng-template>
        </div>
      </div>
    </ng-container>

    <ng-template #loadedTmpl>
      <span>{{ size | number: '1.2-2' }}&nbsp;{{ type | titlecase }}</span>

      <ng-container *ngIf="isBlobLoaded">
        <tdv-spinner
          *ngIf="isTypeDetectionProgress; else finishedTmpl"
        ></tdv-spinner>
      </ng-container>
    </ng-template>
  </div>
</div>

<ng-template #finishedTmpl>
  <div
    class="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-content-center mr-4"
  >
    <tdv-icon-svg-check color="dark" class="w-16 h-16"></tdv-icon-svg-check>
  </div>
</ng-template>
